/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.29/esri/copyright.txt for details.
*/
const a="20240321",b="9cf5a4b8555fda94595b625a40b922e012baf071";export{a as buildDate,b as commitHash};
